module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.inputname)),
      expression: "errors.has(inputname)"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v("Enter a valid time")]), _vm._v(" "), _c('vue-suggest', {
    attrs: {
      "list": _vm.simpleSuggestionList,
      "filter-by-query": true,
      "max-suggestions": 100,
      "min-length": 0,
      "prevent-submit": true
    },
    on: {
      "input": function($event) {
        _vm.valueUpdated($event)
      }
    },
    model: {
      value: (_vm.editData.time),
      callback: function($$v) {
        _vm.$set(_vm.editData, "time", $$v)
      },
      expression: "editData.time"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.initial",
      value: (_vm.validations),
      expression: "validations",
      modifiers: {
        "initial": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editData.time),
      expression: "editData.time"
    }],
    staticClass: "form-control gl-time-suggest-input",
    attrs: {
      "name": _vm.inputname
    },
    domProps: {
      "value": (_vm.editData.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editData, "time", $event.target.value)
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46eab0a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/gl-timesuggest.vue
// module id = 546
// module chunks = 1